import axios from 'axios';

export const GetJob = (id) => {
    return axios.get(`scheduler/jobs/${id}`);
};

export const GetJobs = () => {
    return axios.get(`scheduler/jobs`);
};

export const PostJob = (job) => {
    return axios.post(`scheduler/jobs`, job);
};

export const PatchJob = (job) => {
    return axios.patch(`scheduler/jobs/${job.id}`, {...job, id: undefined});
};

export const PauseJob = (job) => {
    return axios.post(`scheduler/jobs/${job.id}/pause`);
};

export const ResumeJob = (job) => {
    return axios.post(`scheduler/jobs/${job.id}/resume`);
};

export const RunJob = (job) => {
    return axios.post(`scheduler/jobs/${job.id}/run`);
};

export const RemoveJob = (job) => {
    return axios.delete(`scheduler/jobs/${job.id}`);
};

export const GetJobHistory = (id) => {
    return axios.get(`scheduler/jobs/${id}/history`);
}


// WEBPACK FOOTER //
// ./src/components/http/SchedulerService.js